import { render, staticRenderFns } from "./EditAuctionComponent.vue?vue&type=template&id=64175ffd&"
import script from "./EditAuctionComponent.vue?vue&type=script&lang=js&"
export * from "./EditAuctionComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports